import { TPricingPlansState } from "./pricingPlans.types";

export const initialState: TPricingPlansState = {
  data: [],
  isLoading: false,
  error: null,
};
